<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-10">
          <v-alert v-if="emailChanged" dense text type="success">Email changed.<br> Please check your email for an activation link before logging in.</v-alert>
          <login-form/>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';
import { mapActions } from "vuex";

export default {
  components: { LoginForm },
  name: "Login",
  computed: {
    emailChanged() {
      if ("emailChanged" in this.$route.query) {
        return !!this.$route.query.emailChanged;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.updateWindowTitle({newTitle: 'Login'})
  },
  methods: {
    ...mapActions(["updateWindowTitle"]),
  },
};
</script>

<style></style>
